import { Helpers } from '../helpers';

import { parseJSONString } from './util';

export const CallCenterAPI = function (apiConfig, http, wcsHttp) {
    let self = this;
    self.apiConfig = apiConfig;

    self.csrDiscApporve = (orderId, reasonCode, discPerc, logonId, password, usageId = -1) => {
        var params = {
            logonId,
            password,
            usageId,
            discPerc,
            orderId,
            reasonCode,
            storeId: 10151,
            langId: -1,
            catalogId: 10051,
            ccf: false,
        };
        return http.post('AjaxCSRDiscApproveCmd', Helpers.parseFormData(params, false)).then(resp => {
            const { data } = resp;
            return parseJSONString(data);
        });
    };
    self.csrDiscount = (
        orderId,
        discPerc,
        reasonCode,
        orderItemId,
        discAmtItem,
        discField,
        bdCode,
        usageId = -1,
        approvalRespons,
    ) => {
        var params = {
            orderId,
            discPerc,
            reasonCode,
            bdCode,
            usageId,
            finalView: 'AjaxOrderItemDisplayView',
            storeId: 10151,
            langId: -1,
            catalogId: 10051,
            ccf: false,
            ...(orderItemId ? { orderItemId, discAmtItem, discField } : {}),
        };
        if (approvalRespons) {
            params.CSR_DISC_APPROVED_AGENT = approvalRespons.CSR_DISC_APPROVED_AGENT;
            params.CSR_DISC_APPROVE_ORDER = approvalRespons.CSR_DISC_APPROVE_ORDER;
            params.CSR_MAX_APPROVEL_PERC_LIMIT = approvalRespons.CSR_MAX_APPROVEL_PERC_LIMIT;
            params.CSR_DISC_APPROVED_PERCENT = approvalRespons.CSR_DISC_APPROVED_PERCENT;
        }
        return http.post('AjaxCSRDiscountCmd', Helpers.parseFormData(params, false)).then(resp => {
            const { data } = resp;
            return parseJSONString(data);
        });
    };
    self.emailQuote = () => {
        return http.post('emailQuote', {});
    };
    self.manageLVOFlag = (orderId, checked) => {
        const params = {
            catalogId: '10051',
            langId: '-1',
            lvoFlag: checked ? 1 : 0,
            orderId,
            storeId: '10151',
        };
        return http.post('ccAjaxManageLVOFlag', Helpers.parseFormData(params));
    };
    self.manageOrderLock = action => {
        var params = {
            ccAction: action,
            storeId: apiConfig.siteInfo.storeId,
        };

        return http.post('ccAjaxManageOrderLock', Helpers.parseFormData(params));
    };
    self.orderLockHelper = () => {
        return http.post('ccAjaxOrderLockHelper', {});
    };

    self.priceOverride = id => {
        const { siteInfo } = self.apiConfig;
        const { storeId } = siteInfo;
        return wcsHttp.get(`${storeId}/HPCartService/getAgentPriceOverrideLimit`, { params: { orderId: id } });
    };
};
